@if (columnParam.filterType === 'PRODUCT_ARTICLE_MULTI_SELECT') {
  <app-dynamic-single-select-table-item
    [columnParam]="columnParam"
    [value]="record[columnParam.key]"
    [record]="record"
    [isEdit]="isEditModeActive"
    [isEditable]="columnParam.editable"
    [currentTableZoom]="currentTableZoom"
    [dynamicValue]="columnParam.key === 'productId' ? record['article'] : record['productId']"
    (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
  />
} @else {
  @switch (columnParam.type) {
    @case ('TEXT') {
      <app-text-record-table-item
        [columnParam]="columnParam"
        [value]="record[columnParam.key]"
        [record]="record"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        [currentTableZoom]="currentTableZoom"
        (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
      />
    }
    @case ('NUMERIC') {
      <app-number-record-table-item
        [columnParam]="columnParam"
        [value]="record[columnParam.key]"
        [record]="record"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        [currentTableZoom]="currentTableZoom"
        (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
      />
    }
    @case ('NUMBER') {
      <app-number-record-table-item
        [columnParam]="columnParam"
        [value]="record[columnParam.key]"
        [record]="record"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        [currentTableZoom]="currentTableZoom"
        (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
      />
    }
    @case ('DATE') {
      <app-date-record-table-item
        [columnParam]="columnParam"
        [value]="record[columnParam.key]"
        [record]="record"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        [currentTableZoom]="currentTableZoom"
        (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
      />
    }
    @case ('DATE_YEAR') {
      <app-year-record-table-item
        [columnParam]="columnParam"
        [value]="record[columnParam.key]"
        [record]="record"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        [currentTableZoom]="currentTableZoom"
        (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
      />
    }
    @case ('DATE_MONTH_YEAR') {
      <app-month-year-record-table-item
        [columnParam]="columnParam"
        [value]="record[columnParam.key]"
        [record]="record"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        [currentTableZoom]="currentTableZoom"
        (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
      />
    }
    @case ('TIME') {
      <app-time-record-table-item
        [columnParam]="columnParam"
        [value]="record[columnParam.key]"
        [record]="record"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        [currentTableZoom]="currentTableZoom"
        (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
      />
    }
    @case ('SELECT') {
      <app-single-select-table-item
        [columnParam]="columnParam"
        [value]="record[columnParam.key]"
        [record]="record"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        [currentTableZoom]="currentTableZoom"
        (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
      />
    }
    @case ('ENUM_SELECT') {
      <app-single-select-table-item
        [columnParam]="columnParam"
        [value]="record[columnParam.key]"
        [record]="record"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        [currentTableZoom]="currentTableZoom"
        (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
      />
    }
    @case ('MODAL') {
      <app-modal-record-table-item
        [columnParam]="columnParam"
        [recordData]="record"
        [resourceParams]="resourceParams"
        [isDataExists]="isDataExists(columnParam, record)"
        (reloadTableData)="handleReloadTableData()"
      />
    }
    @case ('IFRAME') {
      <app-modal-record-table-item
        [columnParam]="columnParam"
        [recordData]="record"
        [resourceParams]="resourceParams"
        [isDataExists]="isDataExists(columnParam, record)"
        (reloadTableData)="handleReloadTableData()"
      />
    }
    @case ('BOOLEAN') {
      <app-boolean-record-table-item
        [columnParam]="columnParam"
        [record]="record"
        [value]="record[columnParam.key]"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
      />
    }
    @case ('COLOR') {
      <app-color-record-table-item
        [columnParam]="columnParam"
        [record]="record"
        [value]="record[columnParam.key]"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
      />
    }
    @case ('CHIPS') {
      <app-chips-record-table-item
        [columnParam]="columnParam"
        [record]="record"
        [value]="record[columnParam.key]"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
      />
    }
    @case ('MULTI_SELECT') {
      <app-multi-select-table-item
        [columnParam]="columnParam"
        [record]="record"
        [value]="record[columnParam.key]"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
      />
    }
    @case ('ENUM_MULTI_SELECT') {
      <app-multi-select-table-item
        [columnParam]="columnParam"
        [record]="record"
        [value]="record[columnParam.key]"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        (valueChanged)="handleRecordUpdate(record.id, columnParam.key, $event)"
      />
    }
    @case ('OBJECT_PLAN_FACT') {
      <app-plan-fact-item
        [columnParam]="columnParam"
        [record]="record"
        [value]="record[columnParam.key]"
        [isEdit]="isEditModeActive"
      />
    }
    @case ('PHOTO') {
      <app-photo-table-item
        [columnParam]="columnParam"
        [value]="record[columnParam.key]"
        [record]="record"
        [isEdit]="isEditModeActive"
        [isEditable]="columnParam.editable"
        [currentTableZoom]="currentTableZoom"
      />
    }
    @default {
      <div
        class="value-container"
        [matTooltip]="getStringValue(record[columnParam.key])"
        [matTooltipShowDelay]="1500"
      >
        {{ record[columnParam.key] }}
      </div>
    }
  }
}

